import { type StopEditingEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function stopEditingReducer(
  state: SelectionState,
  event: StopEditingEvent
): ReducerResponse {
  if (!state.focusedCell || !state.isEditing) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: { ...state, isEditing: false },
    delta: {
      kind: 'cellEditStopped',
      position: state.focusedCell,
      source: event.source,
    },
  };
}
